export default class Datepicker {
	constructor(checkIn) {
		if (!checkIn) return;

		let checkInPicker;

		checkInPicker = new AirDatepicker(checkIn, {
			dateFormat: "dd-MM-yyyy",
			keyboardNav: false,
			// locale: localeEn,
			autoClose: true,
			buttons: ["clear"],
			// range: true,
			// multipleDatesSeparator: ' - ',
			onSelect({ date, formattedDate, datepicker }) {
				// console.log(date);
				// console.log(formattedDate.join(' - '));
				// console.log(datepicker.$sel);
				// datepicker.$el.value = formattedDate.join(' - ');
			},
		});
	}
}
